var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBars(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 1.34375C0.125 0.886719 0.476562 0.5 0.96875 0.5H15.0312C15.4883 0.5 15.875 0.886719 15.875 1.34375C15.875 1.83594 15.4883 2.1875 15.0312 2.1875H0.96875C0.476562 2.1875 0.125 1.83594 0.125 1.34375ZM0.125 6.96875C0.125 6.51172 0.476562 6.125 0.96875 6.125H15.0312C15.4883 6.125 15.875 6.51172 15.875 6.96875C15.875 7.46094 15.4883 7.8125 15.0312 7.8125H0.96875C0.476562 7.8125 0.125 7.46094 0.125 6.96875ZM15.0312 13.4375H0.96875C0.476562 13.4375 0.125 13.0859 0.125 12.5938C0.125 12.1367 0.476562 11.75 0.96875 11.75H15.0312C15.4883 11.75 15.875 12.1367 15.875 12.5938C15.875 13.0859 15.4883 13.4375 15.0312 13.4375Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBars);
export default __webpack_public_path__ + "static/media/bars.009bbd4cd2709ee7a845ae1082f75712.svg";
export { ForwardRef as ReactComponent };